// 引入数据配置文件
import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
// 引入时间格式转换方法
import { formatDate } from "@/utils/validate.js";
// 引入证书页面
import RegPersonReginfo from "../../regPersonReginfo/index.vue";
// 引入附件上传页面
import CorpPictureinfor from "../../../components/pictureinfor/index.vue";
// 引入历史核验记录页面
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
export default {
  data() {
    return {
      // 注册人员证书弹窗状态
      dialogVisible: false,
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        personName: null, // 姓名
        sexNum: null, // 性别
        idCardTypeNum: null, // 证件类型
        idCard: null, // 证件号码
        birthDay: null, // 出生日期
        nationlityNum: null, // 民族
        eduLevelNum: null, // 学历
        degreeNum: null, // 学位
        mobile: null, // 手机号码
        corpId: null, // 所属交易人
        corpName: null, // 所属交易名称
        auditState: null, // 核验状态
        auditStateName: null, // 核验状态名称
        state: null, // 异动状态
        description: null, // 备注
        regionCode: null, // 所在行政区域代码
        postAddress: null, // 通讯地址
        zipCode: null, // 邮政编码
        onJob: null, // 是否在职
        job: null, // 职务
        techTitle: null, // 技术职称
        workingExperience: null, // 从业经历
        workingYear: null, // 从业年限
        certificateType: null, // 证书类型
        certificateNumber: null, // 证书编号
        certificationUnit: null, // 发证单位
        certificationDate: null, // 发证日期
        socialInsurancePayment: null, // 社会保险缴纳情况
        certificationEndDate: null, // 证书截止时间
        loginName: null, // 登录名
        lxrdzyx: null // 联系人电子邮箱
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      controllerFlg: null, // 页面类型
      isEdit: null, // 是否可编辑
      lxrdzyxShow: false, // 电子邮箱不置灰
      workingYearShow: false, // 从业年限不置灰
      userFlag: sessionStorage.getItem("userFlag"), // 登录角色标识
      userType: sessionStorage.getItem("userType"), // 用户类型
      // 全局加载
      fullLoading: null,
    };
  },
  // 接收父组件传递的数据
  props: {
    // 页面类型
    params: {
      type: Object,
      default: {}
    }
  },
  // 注册组件
  components: {
    // 证书一览
    RegPersonReginfo,
    // 附件上传一览
    CorpPictureinfor,
    // 历史核验记录一览
    AuditHistoryRecord
  },
  // 模板编译完成
  mounted() {
    // 判断是否为工作人员
    if(this.userFlag === "工作人员" || this.userType === "201508061647510026"){
      // 获取数据
      this.params = this.$route.query;
    }
    // 打开loading
    this.loading = true;
    // 设置页面类型
    this.controllerFlg = this.params.type;
    // 获取详情信息
    this.fun_Details();
    // 如果是详情
    if (this.params.type == "details") {
      // 遍历表单
      this.formConfigList.map(e => {
        // 遍历
        e.formConfigList.map(form => {
          // 不可编辑
          form.disabled = true;
        });
      });
    }
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/regPersonBasicinfo/detail", {
        id: this.params.id
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data.detail;
          // 设置是否可编辑
          this.isEdit = data.isEdit;
          // 是否可编辑不为空
          if (this.isEdit != "" && this.isEdit != null) {
            // 遍历表单
            this.formConfigList.map(e => {
              // 如果是证件号码或者证件类型
              if (e.value == "idCardTypeNum" || e.value == "idCard") {
                // 不可编辑
                e.disabled = true;
              }
            });
          }
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 所在省
      if (i === "provinceNum") {
        // 赋值
        this.form.provinceNum = e;
        // 遍历
        this.formConfigList[0].formConfigList.map(e => {
          // 如果是所在市
          if (e.value === "regionCode") {
            // 修改下拉框请求参数，重新赋值
            e.queryParams = {
              url: "/administrativeArea/administrativeAreaList",
              parentAreaCode: this.form.provinceNum,
              levelNum: "201507041523190005"
            };
          }
        });
      } else {
        // 赋值
        this.form[i] = e;
      }
    },
    /**
     * @description 保存或修改
     * @author
     */
    fun_SaveOrUpdate() {
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 出生日期不为空时
          if (this.form.birthDay != "" && this.form.birthDay != null) {
            // 截取年月日
            this.form.birthDay = formatDate(
              new Date(this.form.birthDay),
              "yyyy-MM-dd"
            );
          }
          // 发证日期不为空时
          if (
            this.form.certificationDate != "" &&
            this.form.certificationDate != null
          ) {
            // 截取年月日
            this.form.certificationDate = formatDate(
              new Date(this.form.certificationDate),
              "yyyy-MM-dd"
            );
          }
          // 证书有效期截止日期不为空时
          if (
            this.form.certificationEndDate != "" &&
            this.form.certificationEndDate != null
          ) {
            // 截取年月日
            this.form.certificationEndDate = formatDate(
              new Date(this.form.certificationEndDate),
              "yyyy-MM-dd"
            );
          }
          // 打开遮罩
          this.fun_Loading();
          // 请求
          fun_PostAction("/regPersonBasicinfo/saveOrUpdate", {
            ...this.form, // form表单数据
            controllerFlg: this.controllerFlg // 操作标志
          }).then(res => {
            // 加载框取消
            this.fullLoading.close();
            // 解构res.data
            const { result, msg } = res.data;
            // 解析后台返回的结果集，判断是否成功
            if (result) {
              // 保存时
              if (this.form.auditState === 'bc') {
                // 弹出提示
                this.$alert("项目负责人基本信息保存成功！请上传相关证照的扫描件！", "warning").then(() => {
                  // 修改操作类型
                  this.controllerFlg = 'update';
                  // 主键
                  this.params.id = data;
                  // 重新加载详情
                  this.fun_Details();
                })
                .catch(() => {
                  // 修改操作类型
                  this.controllerFlg = 'update';
                  // 主键
                  this.paramsObj.id = data;
                  // 重新加载详情
                  this.fun_Details();
                }); 
              } else {
                // 操作成功
                this.$message.success(msg);
                // 返回一览
                this.fun_Back();
              }
            } else {
              // 请求失败，弹出失败msg的消息提示
              this.$message.error(msg);
              // 返回一览
              this.fun_Back();
            }
            // 关闭loading
            this.loading = false;
          })
          .catch(() => {
            // 加载框取消
            this.fullLoading.close();
          });
        } else {
          // 关闭loading
          this.loading = false;
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 全局加载
     * @author liutong
     */
    fun_Loading(val) {
      this.fullLoading = this.$loading({
        lock: true,
        text: val ? val : "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * @description 保存，提交
     * @author
     */
    fun_Submit(e) {
      // 打开loading
      this.loading = true;
      // 设置核验状态
      this.form.auditState = e;
      // 如果是进行保存操作
      if (e == "bc") {
        // 进行提交操作
        this.fun_SaveOrUpdate();
      }
      // 如果是进行提交操作
      else {
        // 弹出询问confirm
        this.$confirm(
          "您是否已经阅读免责声明，确认提交吗？提交后您的信息将会直接通过！用户须确认在市公共资源交易主体数据库填报的所有信息，均合法、真实、准确、有效，无任何伪造、修改、虚假成份，并对所提供信息的真实性负责。",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          // 进行提交操作
          this.fun_SaveOrUpdate();
        });
      }
    },
    /**
     * 注册人员证书信息跳转
     */
    fun_RegPersonReginfo() {
      // 打开弹窗
      this.dialogVisible = true;
      // 回调函数
      this.$nextTick(() => {
        // 详情弹窗
        this.$refs.regPersonReginfo.detailDialogVisible = false;
        // 设置弹框页面类型
        this.$refs.regPersonReginfo.controllerFlg = this.controllerFlg;
        // 设置弹框页面注册人员主键
        this.$refs.regPersonReginfo.regBasicinfoId = this.form.id;
        // 设置所属企业
        this.$refs.regPersonReginfo.corpName = this.form.corpName;
        // 打开弹框时调用
        this.$refs.regPersonReginfo.fun_GetOpen();
      });
    },
    /**
     * 附件上传
     */
    fun_GetPictureinfor() {
      // 打开弹窗
      this.$refs.corpPictureinfor.dialogVisible = true;
      // 打开弹框时调用
      this.$refs.corpPictureinfor.fun_GetOpen();
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 判断是工作人员
      if(this.userFlag === '工作人员' || this.userType === "201508061647510026"){
        // 返回
        this.$router.back();
      }
      // 返回
      this.$emit("fun_Back");
    }
  }
};
